var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex align-center" },
    [
      _c("v-menu", {
        attrs: { "min-width": "120px", "max-width": "200px", "offset-y": "" },
        scopedSlots: _vm._u([
          {
            key: "activator",
            fn: function({ on, attrs }) {
              return [
                _vm.$vuetify.breakpoint.mdAndUp
                  ? _c(
                      "div",
                      _vm._g(
                        _vm._b(
                          {
                            staticClass: "info--text cursor-pointer",
                            class: {
                              "mr-4 btn-text": _vm.$vuetify.breakpoint.mdAndUp
                            },
                            on: { click: _vm.onViewProfile }
                          },
                          "div",
                          attrs,
                          false
                        ),
                        on
                      ),
                      [
                        _vm._v(
                          " Xin chào phụ huynh " + _vm._s(_vm.user.name) + " "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            }
          }
        ]),
        model: {
          value: _vm.showMenu,
          callback: function($$v) {
            _vm.showMenu = $$v
          },
          expression: "showMenu"
        }
      }),
      _vm.$vuetify.breakpoint.smAndDown
        ? _c(
            "v-icon",
            {
              staticClass: "cursor-pointer",
              attrs: { color: "primary" },
              on: { click: _vm.onViewProfile }
            },
            [_vm._v("mdi-qrcode")]
          )
        : _vm._e(),
      _c(
        "v-btn",
        {
          staticClass: "text-none ml-3",
          attrs: { color: "primary", outlined: "", rounded: "" },
          on: {
            click: function($event) {
              return _vm.$router.push("/surveys")
            }
          }
        },
        [
          _c("v-icon", { attrs: { left: _vm.$vuetify.breakpoint.mdAndUp } }, [
            _vm._v("mdi-clipboard-text-outline")
          ]),
          _vm.$vuetify.breakpoint.mdAndUp
            ? _c("span", [_vm._v("Khảo sát")])
            : _vm._e()
        ],
        1
      ),
      _vm.isOpen
        ? _c(
            "v-btn",
            {
              staticClass: "text-none ml-6",
              class: { "mr-4 btn-text": _vm.$vuetify.breakpoint.mdAndUp },
              attrs: { color: "error", outlined: "", rounded: "" },
              on: {
                click: function($event) {
                  return _vm.onSignOut()
                }
              }
            },
            [_vm._v("Đăng xuất")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }